import React from 'react';
import PropTypes from 'prop-types';

import { BaIconChevronLeft } from 'components/ui/icons';

import './styles.scss';

const CardCreateSubsectionHeader = ({ className, onBack, title, Icon }) => {

  return (
    <div className={`card-create-subsection-header-container ${className}`}>
      {onBack &&
        <button className="card-create-subsection-header-back" onClick={onBack}><BaIconChevronLeft/> BACK</button>
      }
      <Icon className="card-create-subsection-header-icon"/>
      <span className="card-create-subsection-header-title">{title}</span>
    </div>
  );
}


CardCreateSubsectionHeader.propTypes = {
  className: PropTypes.string,
  onBack: PropTypes.func,
  title: PropTypes.string,
  Icon: PropTypes.elementType.isRequired
};

CardCreateSubsectionHeader.defaultProps = {
  className: ''
};

export default CardCreateSubsectionHeader;
